import React from 'react';
import { LoadingStatus } from './enum/LoadingStatus';

export interface INewsLoadingContext {
    classificationLoading: LoadingStatus,
    setClassificationLoading: (status: LoadingStatus) => void,
    categorizationLoading: LoadingStatus,
    setCategorizationLoading: (status: LoadingStatus) => void,
    vehicleLoading: LoadingStatus,
    setVehicleLoading: (status: LoadingStatus) => void,
}

export const newsLoadingContextInitial: INewsLoadingContext = {
    classificationLoading: LoadingStatus.NOT_STARTED,
    setClassificationLoading: () => { ''; },
    categorizationLoading: LoadingStatus.NOT_STARTED,
    setCategorizationLoading: () => { ''; },
    vehicleLoading: LoadingStatus.NOT_STARTED,
    setVehicleLoading: () => { ''; },
};

export const NewsLoadingContext = React.createContext(newsLoadingContextInitial);



